// api
import axios from 'axios';
// utils
import { url } from 'utils/urls';
import { getFormEncodedData } from '@insticator/insticator-ui'; // iui-utils

const withCredentials = true;

export const userSignInCall = (data) => {
    const encodedData = getFormEncodedData({ username: data.email, password: data.password });
    const headers = { "Content-Type": "application/x-www-form-urlencoded" };
    return axios.post(url.ppa.auth.login, encodedData, { headers, withCredentials });
};

export const userSignOutCall = () => axios.get(`${url.ppa.auth.logout}`, { withCredentials });

export const unmockUserCall = () =>  {
    const headers = { "Content-Type": "application/json" };
    return axios.post(url.ppa.auth.unmock, {}, { headers, withCredentials } )
};

export const userPermissionsCall = userUUID => axios.get(`${url.ppa.users}/${userUUID}/permissions`, {withCredentials });

export const requestDemoCall = data => {
    const headers = { "Content-Type": "application/json" };
    return axios.post(url.ppa.leads, data, { headers, withCredentials })
};

export const userSendResetEmail = data => {
    const headers = { "Content-Type": "application/json" };
    return axios.post(`${url.ppa.auth.password}/send-email`, data, { headers, withCredentials })
};

export const resetPasswordCall = data => {
    const headers = { "Content-Type": "application/json" };
    return axios.put(`${url.ppa.auth.resetPassword}`, data, { headers, withCredentials })
};

export const createUserCall = data => {
    const headers = { "Content-Type": "application/json" };
    return axios.put(url.ppa.auth.activateUser, data, { headers, withCredentials })
};

export const getAuthTokenDataCall = tokenUUID => axios.get(`${url.ppa.auth.token}?tokenUUID=${tokenUUID}`, { withCredentials });

export const userExtendSession = () => axios.put(`${url.ppa.auth.extendSession}`, {} ,{ withCredentials });

export const updateAgreement = (agreementUUID, userUUID) => axios.put(`${url.ppa.agreements}/${agreementUUID}`, { userUUID }, { withCredentials });

export const extendAdminPanelSession = () => axios.put(`${url.embed.admin.extendSession}`, {} ,{ withCredentials });
